import React from 'react';
import './FactionSuccubesDescription.css';
import DescriptionValueWithIcon from "../../../PolicyCardOverlay/DescriptionValueWithIcon/DescriptionValueWithIcon";
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import {MINUS_SIGN} from "../../../../constants/text";
import {
  SUCCUBES_SEDUCTION_COST,
  SUCCUBES_SEDUCTION_RANGE,
  SUCCUBES_SEDUCTION_SUCCESS_THRESHOLD
} from "../../../../configs/factions/succubes";

const FactionSuccubesDescription = () => {
  const unitFriend = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;

  const catapult = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d4 friend.png'}
    alt={'Катапульта'}
    title={'Катапульта'}
  />;

  const ability = <img
    className={'faction-description-icon faction-description-icon-margin-right'}
    src={'/img/icons/ability.png'}
    alt={'Способность'}
    title={'Способность'}
  />;

  const distance = <img
    className={'policy-description-icon'}
    src={'/img/icons/distance.png'}
    alt={'Дальность'}
    title={'Дальность'}
  />;

  const rangeValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={distance}
    icon={SUCCUBES_SEDUCTION_RANGE}
  />;

  const cost = <CoinsStat
    text={SUCCUBES_SEDUCTION_COST}
    noShrinkOnMobile={true}
    isDarkColor={true}
    className={'policy-description-icon-margin-left'}
  />;

  const unitEnemy = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 enemy.png'}
    alt={'Отряд противника'}
    title={'Отряд противника'}
  />;

  const dice = <img
    className={'policy-description-icon'}
    src={'/img/icons/dice.png'}
    alt={'Бросок кости'}
    title={'Бросок кости'}
  />;

  const diceValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right'}
    value={'d20'}
    icon={dice}
  />;

  const size = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/unit size.png'}
    alt={'Размер отряда'}
    title={'Размер отряда суккубов'}
  />;

  // Численность отряда цели - тот же силуэт, что и size, но красным (цвет
  // вражеского отряда, как text-war), поэтому маска+заливка, а не img (url()
  // задаётся инлайн-стилем, а не в CSS-файле - см. GiantUnitIcon в
  // FactionGiantsDescription: css-loader не резолвит абсолютные /img/...
  // пути из public в самих CSS-файлах). Путь - в кавычках: в имени файла
  // пробел, а внутри url(...) без кавычек это ломает CSS-токен
  const sizeEnemy = <span
    className={'policy-description-icon policy-description-icon-margin-right-left faction-succubes-description_size-icon-enemy'}
    style={{
      WebkitMaskImage: 'url("/img/icons/unit size.png")',
      maskImage: 'url("/img/icons/unit size.png")',
    }}
    role={'img'}
    aria-label={'Размер отряда цели'}
    title={'Размер отряда цели'}
  />;

  return (
    <>
      <div className="policy-description_line">
        {unitFriend} (кроме {catapult}) имеют способность
      </div>
      <div className="policy-description_line">
        {ability} <span className={'text-succubes'}>Соблазн</span> {rangeValueAndIcon} {cost}:
      </div>
      <div className="policy-description_line">
        {diceValueAndIcon}+{size}{MINUS_SIGN}{sizeEnemy}: успех {SUCCUBES_SEDUCTION_SUCCESS_THRESHOLD}+.
      </div>
      <div className="policy-description_line">
        Подчиняет {unitEnemy} с сохранением
      </div>
      <div className="policy-description_line">
        свойств и способностей фракции.
      </div>
    </>
  );
};

export default FactionSuccubesDescription;
